var TechnicianSortableAttributes;
(function (TechnicianSortableAttributes) {
    TechnicianSortableAttributes["NAME"] = "name";
})(TechnicianSortableAttributes || (TechnicianSortableAttributes = {}));
export default TechnicianSortableAttributes;
